import { GridLayout } from '@antv/layout/lib/layout/grid';

export default GridLayout;
